// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","FlagImg":"Card_FlagImg__13Yf2","glowOnHover":"Card_glowOnHover__5KsVE","glowing":"Card_glowing__1gxSb"};